import React, { useMemo, useRef } from 'react';
// 引入柱状图
import 'echarts/lib/chart/line';
// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
// 使用样式
import 'echarts/theme/macarons';
import './index.scss';
import ErrorGameImg from '@/pages/opinion/assets/svg/gameError.svg';
import { echartsContent } from '@/pages/opinion/utils';
import EChartCommon from '@/pages/opinion/components/EChartCommon';
function toEchartsTooltipPie(params: any) {
  let returnData = '';
  if (params.seriesName != '' && params.seriesName != null) {
    returnData +=
      '<span style="color: #000;">' +
      params.data.name +
      '</span>' +
      '</br>' +
      "<span style='margin-right:20px'>Mentions</span>" +
      "<span style='color:#000;font-weight:bolder'>" +
      echartsContent(params.data.trueValue[0]) +
      '</span>' +
      '</br>' +
      "<span style='margin-right:15px'>Sentiment</span>" +
      "<span style='color:#000;font-weight:bolder'>" +
      params.data.trueValue[1].toFixed(2) +
      '</span>';
  }
  return returnData;
}
export default function CoordinateChart({
  scatterData,
  filterParams,
  handleOnClick,
  height = 260,
  isCompetitor,
  isDetail,
  dataIndex,
  mentionsData,
  onChaneTab,
  transFunc = (name: string) => name,
}: any) {
  // 数据，是否是详情页，数据坐标（默认选中） 
  const chartRef = useRef(null);

  // 对于连线数据处理
  const handleConnect = (seriesArry: any) => {
    let dataArry: any = [];
    let dataCopyArry: any = [];
    seriesArry[0].data.map((item: any) => {
      if (item['trueValue'][0] != 0 && item['trueValue'][1] != 0) {
        dataCopyArry.push(item);
      }
    });
    dataCopyArry.map((item: any, index: number) => {
      if (index != 0) {
        item.itemStyle = {
          opacity: 0.5,
        };
      } else {
        item.itemStyle = {
          opacity: 1,
        };
      }
      if (index < dataCopyArry.length - 1) {
        dataArry.push([
          { coord: dataCopyArry[index]['value'] },
          { coord: dataCopyArry[index + 1]['value'] },
        ]);
      }
    });
    return {
      //折线坐标数据
      connectArry: dataArry,
      // echarts图数据
      allData: dataCopyArry,
    };
  };
  const initMentions = (data: any) => {
    if (data) {
      let option: any = {
        tooltip: {
          formatter: (params: any) => {
            return toEchartsTooltipPie(params);
          },
        },
        title: [
          {
            text: 'Positive but\nFew Mentions',
            left: 0,
            top: 0,
            textStyle: {
              width: 10,
              fontSize: 16,
              color: '#8CE3A6',
            },
          },
          {
            text: 'Positive and\nMore  Mentions',
            right: 0,
            top: 0,
            textStyle: {
              width: 10,
              fontSize: 16,
              color: '#8CE3A6',
            },
          },
          {
            text: 'Negative and\nFew Mentions',
            left: 0,
            bottom: 0,
            textStyle: {
              width: 10,
              fontSize: 16,
              color: '#F3AEB2',
            },
          },
          {
            text: 'Negative but\nMore  Mentions',
            right: 0,
            bottom: 0,
            textStyle: {
              width: 10,
              fontSize: 16,
              color: '#F3AEB2',
            },
          },
        ],
        xAxis: {
          max: 0,
          min: 0,
          axisLabel: { show: false },
          splitLine: { show: false },
          axisLine: {
            lineStyle: { color: '#DDDDDD' },
          },
        },
        yAxis: {
          max: 2,
          min: -2,
          axisLabel: { show: false },
          splitLine: { show: false },
          axisLine: {
            lineStyle: { color: '#DDDDDD' },
          },
        },
        grid: {
          top: 0,
          containLabel: true,
          right: 0,
          bottom: 0,
          left: 0,
        },
        series: [
          {
            type: 'scatter',
            data: [],
          },
        ],
      };

      let mentionsArr: any = [];
      let sentimentArr: any = [];

      data.map((v: any) => {
        mentionsArr.push(v.mentions);
        sentimentArr.push(v.sentiment);
      });
      const maxValue = Math.max(...mentionsArr);

      data.map((v: any) => {
        option.series[0].data.push({
          value: [v.mentions - maxValue / 2, v.sentiment - 3],
          symbol: v.cover ? 'image://' + v.cover : 'image://' + ErrorGameImg,
          trueValue: [v.mentions, v.sentiment],
          name: v.name ? v.name : v.version,
          itemStyle: {
            opacity: 1,
          },
          symbolSize: v.entity_type == 'pc' ? 36 : 24,
        });
        if (filterParams?.statistics_field === 'version') {
          option.series[0].markLine = {
            lineStyle: {
              type: 'solid',
              opacity: 0.5,
            },
            data: handleConnect(option.series).connectArry,
            silent: false,
          };
          option.series[0].data = handleConnect(option.series).allData;
        }
      });

      option.xAxis.max = (Math.max(...mentionsArr) * 1.1) / 2;
      option.xAxis.min = (-Math.max(...mentionsArr) * 1.1) / 2;
      option.yAxis.max = (Math.max(...sentimentArr) * 1.1) / 2;
      option.yAxis.min = (-Math.max(...sentimentArr) * 1.1) / 2;
 

      return option;
    } else {
      return {};
    }
  };

  const options = useMemo(() => {
    return initMentions(scatterData);
  }, [scatterData, filterParams]);

  return (
    <div className="coordinate-chart-wrapper" style={{ height: height - 10 }}>
      <EChartCommon
        ref={chartRef}
        height={height - 10}
        optionsProps={{ noMerge: true }}
        options={options}
        eventsDict={{
          click: (params: any) => {
            // console.log(params);
            handleOnClick?.(params);
          },
        }}
      ></EChartCommon>
      <div className="yLine">
        <span style={{ color: '#888888' }}>Negative</span>
        <span style={{ color: '#191919' }}>Sentiment</span>
        <span style={{ color: '#888888' }}>Positive</span>
      </div>
      <div className="xLine">
        <span style={{ color: '#888888' }}>Few</span>
        <span style={{ color: '#191919' }}>Mentions</span>
        <span style={{ color: '#888888' }}>More</span>
      </div>
    </div>
  );
}
